module.exports = __webpack_public_path__ + "img/cabin-front.de78ded1.webp";